import { styled } from '@mui/material'

export const Container = styled('div')`
  margin: ${({ theme }) => theme.spacing(2.5)};
`
